import React from 'react';

import Layout from '../components/Layout';

const IndexPage = () => (
        <Layout fullMenu>
            <article id="main">
                <header className="major">
                    <h2>Impressum & Datenschutz</h2>
                    <p>
                        Verantwortlich: Timo Buhmann, Stuttgart, Deutschland
                        <br/>
                        E-Mail: webmaster&#160;<span className="icon solid fa-at">&#160;</span>butimo.info
                    </p>
                </header>
                <section className="wrapper style5">
                    <div className="inner">
                        <p>Stand: 23. März 2026</p>
                        <h3>DATENSCHUTZ</h3>

                        <h4>VERANTWORTLICHER</h4>
                        <p>
                            Timo Buhmann<br/>
                            Stuttgart, Deutschland<br/>
                            webmaster  butimo.info<br/>
                        </p>

                        <h4>BEREITSTELLUNG DER WEBSITE UND HOSTING</h4>
                        <p>
                            Beim Aufruf dieser Website werden durch den Webserver automatisch Informationen erfasst (Server-Logfiles). Dazu gehören insbesondere:
                            <ul>
                                <li>IP-Adresse</li>
                                <li>Datum und Uhrzeit der Anfrage</li>
                                <li>aufgerufene Seite</li>
                                <li>Browser und Betriebssystem</li>
                            </ul>
                        </p>
                        <p>Diese Daten sind technisch erforderlich, um die Website bereitzustellen und die Sicherheit zu gewährleisten.</p>
                        <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</p>
                        <p>Die Logfiles werden nach maximal 30 Tagen gelöscht.</p>

                        <h4>SICHERHEIT</h4>
                        <p>Diese Website nutzt eine TLS-Verschlüsselung (HTTPS) zur sicheren Übertragung von Daten.</p>
                        <p></p>

                        <h4>WEBANALYSE (UMAMI)</h4>
                        <p>Diese Website verwendet die Open-Source-Webanalyse-Software Umami, die auf einem eigenen Server betrieben wird.</p>
                        <p>Umami dient der anonymisierten Auswertung der Nutzung dieser Website. Es werden keine Cookies gesetzt und keine personenbezogenen Profile erstellt.</p>
                        <p>
                            Erfasst werden insbesondere:
                            <ul>
                                <li>aufgerufene Seiten</li>
                                <li>Referrer (zuvor besuchte Seite)</li>
                                <li>verwendeter Browser und Gerätetyp</li>
                                <li>ungefähre geografische Herkunft (auf Basis anonymisierter IP-Adressen)</li>
                            </ul>
                        </p>
                        <p>Die Verarbeitung erfolgt ausschließlich anonymisiert. Eine Speicherung von vollständigen IP-Adressen findet nicht statt.</p>
                        <p>Die Daten werden nicht an Dritte weitergegeben.</p>
                        <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</p>

                        <h4>GEWÄHR</h4>
                        <p>
                            ich übernehme keine Gewähr für die Aktualität, Richtigkeit und Vollständigkeit der Informationen
                            auf diesen Seiten oder den jederzeitigen störungsfreien Zugang. Bei Verweisen (Links) auf
                            Internetseiten Dritter übernehme ich keine Verantwortung für die Inhalte der verlinkten Seiten.
                            Weiterhin schließe ich die Haftung bei Serviceleistungen, insbesondere beim Download von durch
                            mich zur Verfügung gestellten Dateien auf den Internetseiten dieser Domain, für leicht
                            fahrlässige Pflichtverletzungen aus.
                        </p>

                        <h4>BILDNACHWEISE</h4>
                        <p>
                            Alle Rechte vorbehalten. Text, Bilder, Grafiken, Ton, Animationen und Videos sowie deren
                            Anordnung auf dieser Domain unterliegen dem Schutz des Urheberrechts und anderer Schutzgesetze.
                            Der Inhalt dieser Website darf nicht zu kommerziellen Zwecken kopiert, verbreitet, verändert
                            oder Dritten zugänglich gemacht werden.
                        </p>
                        <p>
                            Das Bild <b>Ich als Sidemount Taucher</b> wird bereitgestellt von <b>Chris Godlewski</b> -
                            <a href="https://sidemountsociety.com" target="_blank">Sidemount Society</a> - und unterliegt
                            seinem Urheberrecht.
                        </p>
                        <p>
                            Das Bild <b>Person's Left Hand Holding Green Leaf Plant</b> wird bereitgestellt von <b>Alena
                            Koval</b> und unterliegt den
                            auf <a href="https://www.pexels.com/photo/person-s-left-hand-holding-green-leaf-plant-886521/"
                                   target="_blank">Pexel</a> verfügbaren Lizensbestimmungen.
                        </p>
                        <p>
                            Das Bild <b>grayscale photo of person scuba diving</b> wird bereitgestellt von <b>Talia
                            Cohen</b> und unterliegt den
                            auf <a href="https://unsplash.com/photos/AN2SypyyOnA"
                                   target="_blank">Unsplash</a> verfügbaren Lizensbestimmungen.
                        </p>
                        <p>
                            Diese Seite wurde mit <a href="https://www.gatsbyjs.com/" target="_blank">Gatsby</a> erstellt.
                            Danke an <a href="https://github.com/anubhavsrivastava" target="_blank">Anubhav
                            Srivastava</a> für die Bereitstellung
                            der <a href="https://www.gatsbyjs.com/starters/anubhavsrivastava/gatsby-starter-spectral"
                                   target="_blank">Spectral</a> Vorlage.
                        </p>
                    </div>
                </section>
            </article>
        </Layout>
    )
;

export default IndexPage;
